import { BookmarkBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-bookmark';
import { CodeBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-code';
import { DatabaseBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-database';
import { DividerBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-divider';
import {
  EmbedFigmaBlockPlainTextAdapterExtension,
  EmbedGithubBlockPlainTextAdapterExtension,
  EmbedIframeBlockPlainTextAdapterExtension,
  EmbedLinkedDocBlockPlainTextAdapterExtension,
  EmbedLoomBlockPlainTextAdapterExtension,
  EmbedSyncedDocBlockPlainTextAdapterExtension,
  EmbedYoutubeBlockPlainTextAdapterExtension,
} from '@blocksuite/hive-block-embed';
import { LatexBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-latex';
import { ListBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-list';
import { ParagraphBlockPlainTextAdapterExtension } from '@blocksuite/hive-block-paragraph';
import type { ExtensionType } from '@blocksuite/store';

export const defaultBlockPlainTextAdapterMatchers: ExtensionType[] = [
  ParagraphBlockPlainTextAdapterExtension,
  ListBlockPlainTextAdapterExtension,
  DividerBlockPlainTextAdapterExtension,
  CodeBlockPlainTextAdapterExtension,
  BookmarkBlockPlainTextAdapterExtension,
  EmbedFigmaBlockPlainTextAdapterExtension,
  EmbedGithubBlockPlainTextAdapterExtension,
  EmbedLoomBlockPlainTextAdapterExtension,
  EmbedYoutubeBlockPlainTextAdapterExtension,
  EmbedLinkedDocBlockPlainTextAdapterExtension,
  EmbedSyncedDocBlockPlainTextAdapterExtension,
  EmbedIframeBlockPlainTextAdapterExtension,
  LatexBlockPlainTextAdapterExtension,
  DatabaseBlockPlainTextAdapterExtension,
];
